import apiClient from './api'
import type { UserMembership, MembershipHistory, MembershipFilters, MembershipOverrideRequest } from '../types/membership'

export interface MembershipThresholds {
  membership_bronze_threshold: number
  membership_silver_threshold: number
  membership_gold_threshold: number
  membership_platinum_threshold: number
  membership_vip_threshold: number
  membership_bronze_period: 'alltime' | 'yearly'
  membership_silver_period: 'alltime' | 'yearly'
  membership_gold_period: 'alltime' | 'yearly'
  membership_platinum_period: 'alltime' | 'yearly'
  membership_vip_period: 'alltime' | 'yearly'
}

export const membershipService = {
  getMyMembership: async () => {
    const response = await apiClient.get<{ success: boolean; data: UserMembership }>('/memberships/me')
    return response.data
  },

  listMemberships: async (filters?: MembershipFilters) => {
    const response = await apiClient.get<{ success: boolean; data: UserMembership[]; meta: any }>('/admin/memberships', { params: filters })
    return response.data
  },

  getUserMembership: async (userId: string) => {
    const response = await apiClient.get<{ success: boolean; data: UserMembership }>(`/admin/memberships/${userId}`)
    return response.data
  },

  overrideTier: async (userId: string, request: MembershipOverrideRequest) => {
    const response = await apiClient.post<{ success: boolean; data: UserMembership }>(`/admin/memberships/${userId}/override`, request)
    return response.data
  },

  recalculateAll: async () => {
    const response = await apiClient.post<{ success: boolean; message: string }>('/admin/memberships/recalculate')
    return response.data
  },

  getMembershipHistory: async (userId: string) => {
    const response = await apiClient.get<{ success: boolean; data: MembershipHistory[] }>(`/admin/memberships/${userId}/history`)
    return response.data
  },

  getThresholds: async () => {
    const response = await apiClient.get<{ success: boolean; data: MembershipThresholds }>('/admin/membership-config')
    return response.data
  },

  getMyThresholds: async () => {
    const response = await apiClient.get<{ success: boolean; data: MembershipThresholds }>('/memberships/me/thresholds')
    return response.data
  },

  updateThresholds: async (thresholds: {
    bronze: number; bronze_period: 'alltime' | 'yearly'
    silver: number; silver_period: 'alltime' | 'yearly'
    gold: number; gold_period: 'alltime' | 'yearly'
    platinum: number; platinum_period: 'alltime' | 'yearly'
    vip: number; vip_period: 'alltime' | 'yearly'
  }) => {
    const response = await apiClient.post<{ success: boolean; message: string }>('/admin/membership-config', thresholds)
    return response.data
  },
}
